import { useTurnaroundListFilters } from '../hooks/useTurnaroundListFilters';
import SearchFilters from 'components/SearchFilters';
import { TurnaroundListFilters } from 'api/models/TurnaroundList';

export const TurnaroundListFiltersButton = () => {
  const [turnaroundListFilters, setTurnaroundListFilters] = useTurnaroundListFilters();

  return (
    <SearchFilters<TurnaroundListFilters>
      filters={turnaroundListFilters}
      enabledFilters={{
        surgeryDate: 'surgery_date',
        turnaroundStage: 'turnaround_stage',
        supplier: 'supplier',
        surgeon: 'surgeon',
        contents: 'contents',
      }}
      setFilters={setTurnaroundListFilters}
    />
  );
};
